import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/lib/auth.jsx";
import Login from "@/pages/Login.jsx";
import Dashboard from "@/pages/Dashboard.jsx";
import EntryForm from "@/pages/EntryForm.jsx";
import Register from "@/pages/Register.jsx";
import PILedger from "@/pages/PILedger.jsx";
import Ledgers from "@/pages/Ledgers.jsx";
import Salary from "@/pages/Salary.jsx";
import Layout from "@/components/Layout.jsx";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function SalaryOnly({ children }) {
  const { user } = useAuth();
  if (!user?.salary_access) return <Navigate to="/" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading…</div>;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/entry" element={<Protected><EntryForm /></Protected>} />
            <Route path="/entry/:id" element={<Protected><EntryForm /></Protected>} />
            <Route path="/entries" element={<Protected><Register /></Protected>} />
            <Route path="/pi/:number" element={<Protected><PILedger /></Protected>} />
            <Route path="/ledgers" element={<Protected><Ledgers /></Protected>} />
            <Route path="/salary" element={<Protected><SalaryOnly><Salary /></SalaryOnly></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
